import React from 'react';

import { AgentDetails } from '../Components/index';

const Agent = ({ match }) => (
  <AgentDetails header="Agent Overview" id={match.params.id} />
);

export default Agent;
